export default [
    {
        type: "fuzzyMatch",
        label: "Fuzzy String Match (Analyzed)"
    },
    {
        type: "itemEqualsAnalyzed",
        label: "Equals (Ignore case)"
    },
    {
        type: "startsWithAnalyzed",
        label: "Starts With (Ignore case)"
    }
]